// src/realtime/chatConnection.js
import * as signalR from "@microsoft/signalr";

let connection = null;
let currentUrl = null;

const HUB_PATH = "/chatHub";

const computeHubUrl = (baseURL) => {
  const base = (baseURL || "").replace(/\/+$/, "");
  const origin = base.replace(/\/api($|\/)/, ""); // strip trailing /api
  return origin ? `${origin}${HUB_PATH}` : HUB_PATH;
};

/**
 * Returns a singleton SignalR HubConnection for ChatHub.
 * Caller decides when to start() it (so views can share one instance safely).
 */
export function getChatConnection(baseURL) {
  const url = computeHubUrl(baseURL);

  // Rebuild if we don't have one yet or the URL changed
  if (!connection || currentUrl !== url) {
    currentUrl = url;
    connection = new signalR.HubConnectionBuilder()
      .withUrl(url, { withCredentials: true })
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Warning)
      .build();
  }

  return connection;
}
